import { createSlice } from "@reduxjs/toolkit";

const loginSclice = createSlice({
    name: "login",
    initialState: {
        isLogin: false
    },
    reducers: {
        login: (state) => { state.isLogin = true },
        logout: (state) => { state.isLogin = false }
    }
});

export const selectloginLogout = (state) => state.login.isLogin;

export const { login, logout } = loginSclice.actions;

export default loginSclice.reducer;